var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { SET_CREATOR } from '../actions/setCreator';
var initialState = {
    isPopup: false,
    isCreator: false,
    isEditor: false,
};
export function setCreatorReducer(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case SET_CREATOR:
            return __assign(__assign({}, state), { isPopup: action.payload.isPopup, isCreator: action.payload.isCreator, isEditor: action.payload.isEditor });
        default:
            return state;
    }
}
;
//# sourceMappingURL=creator.js.mapvar __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { SET_CREATOR } from '../actions/setCreator';
var initialState = {
    isPopup: false,
    isCreator: false,
    isEditor: false,
};
export function setCreatorReducer(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case SET_CREATOR:
            return __assign(__assign({}, state), { isPopup: action.payload.isPopup, isCreator: action.payload.isCreator, isEditor: action.payload.isEditor });
        default:
            return state;
    }
}
;
//# sourceMappingURL=creator.js.map